import BraRecommendationInitialContainer from './DressToolInitialPage';

export default BraRecommendationInitialContainer;